// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","player":"App_player__mVHhX","dragArea":"App_dragArea__4kE+j","modalOverlay":"App_modalOverlay__AfBXA","modalContent":"App_modalContent__M1CT4"};